import { IDefaultPagesProps } from "../../interfaces/Lms";
import { useParseRouteActions, useForm, useFetchData } from "../../../helpers/GlobalHelper";
import React from "react";
import LmsTable from "../ui/LmsTable";
import LmsFormGenerator, { BCFormController, getInitialValues } from "../ui/LmsFormGenerator";
import { Button, Card } from "semantic-ui-react";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsTabPages from "../ui/LmsTabPages";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const SystemsUsersMainTable = () => {
  const actionsButtons = ["edit", "export"];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="" // TODO: Add loan comments suffix
    sortable={["Created On"]}
  />;
};

const addExternalUserCredentialFields = (myForm) => {
  myForm.addGroupFields([
    myForm.getInputField("First Name"),
    myForm.getInputField("Last Name"),
    myForm.getInputField("Phone", { validations: ["phone"] }),
    myForm.getInputField("Email", { validations: ["email"] }),
    myForm.getCheckboxField("Is Inactive"),
  ]);
  myForm.addGroupFields([
    myForm.getDropdownField("Link To Contact"),
    myForm.getInputField("New Password"),
    myForm.getInputField("Confirm New Password"),
    myForm.getCheckboxField("Is Pending"),
    myForm.getBlankField()
  ]);

  return myForm;
};

const addExternalUserProfileDataFields = (myForm) => {
  myForm.addGroupFields([
    myForm.getNumberField("Default Page Size"),
    myForm.getNumberField("Invalid Attempt Count"),
    myForm.getCalendarField("Password Expiration Date"),
    myForm.getDropdownField("Localisation"),
    myForm.getNumberField("Bank Information SMS Count"),
  ]);
  myForm.addGroupFields([
    myForm.getCheckboxField("Is User Account Locked"),
    myForm.getCheckboxField("Two Factor Authentication"),
    myForm.getCheckboxField("Suppress Email Notifications"),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ]);

  return myForm;
};

const EditExternalUserForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const myForm = addExternalUserCredentialFields(new BCFormController({}, { formLabel: "User Credentials" }));
  const myForm1 = addExternalUserProfileDataFields(new BCFormController({}, { formLabel: "User Profile Data" }));
  const myForm2 = new BCFormController({});
  myForm2.addGroupFields([myForm2.getTextareaField("Description")]);

  const useFormInstance = useForm(getInitialValues([myForm, myForm1, myForm2]));
  const handleSubmit = () => {
    if (FeatureFlags.IS_DEBUG) {
      console.log(useFormInstance); // TODO: Handle Submit Call
    }
  };

  return (<React.Fragment>
    <Card fluid className="padding-20">
      <LmsFormGenerator myForm={myForm} useFormInstance={useFormInstance as any} skipActions/>
      <LmsFormGenerator myForm={myForm1} useFormInstance={useFormInstance as any} skipActions/>
      <LmsFormGenerator myForm={myForm2} useFormInstance={useFormInstance as any} skipActions/>
      <div className="lms-form-generator-submit-container">
        {!useFormInstance.isDisabled && <Button icon={GlobalConstants.Icons.SAVE} basic content={"Save"} onClick={() => handleSubmit()}/>}
        {useFormInstance.isDisabled && <Button icon={GlobalConstants.Icons.EDIT} basic content={"Edit"} onClick={() => useFormInstance.setIsDisabled(false)}/>}
        <Button icon={GlobalConstants.Icons.CLOSE} basic content={"Close"} onClick={() => useFormInstance?.handleClose()}/>
      </div>
    </Card>
    <EditExternalSystemsUsersTables id={id}/>
  </React.Fragment>);
};

const EditExternalSystemsUsersTables = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const loanActionButtons = [
    { text: "Add", path: `systems-external-users/add-loan?userId=${id}` },
    { text: "Edit", path: `systems-external-users/edit-loan/${id}` },
    "remove",
    "export"
  ];

  const rolesActionButtons = [
    { text: "Add", path: `systems-external-users/add-roles?userId=${id}` },
    "remove",
    "export",
    { text: "Add Role Template", action: "add", path: `systems-external-users/add-role-template?userId=${id}` }
  ];

  const tabPages = {
    "Loans": <LmsTable actionButtons={loanActionButtons}/>,
    Roles: <LmsTable actionButtons={rolesActionButtons}/>
  };

  return <LmsTabPages tabPages={tabPages}/>;
};

const AddRoleTable = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  return <LmsTable
    actionButtons={["addselected", "close"]}
    apiSuffix="" // TODO: Add table suffix
    sortable={["Created On"]}
  />;
};

const AddRoleTemplateForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const myForm = new BCFormController({}, { submitSuffix: "" });
  myForm.addCenteredGroup([myForm.getDropdownField("Role Template")]);

  return <LmsFormGenerator myForm={myForm} actions={["save", "close"]}/>;
};

const addLoanFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("User Account")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan")]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Excluded")]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);
  return myForm;
};

const AddLoanForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const myForm = addLoanFields(new BCFormController({}, { submitSuffix: "" })); // TODO: Add submit suffix

  return <LmsFormGenerator myForm={myForm}/>;
};

const EditLoanForm = ({ id }) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const [{ data = {}, isLoading, error }] = useFetchData(`${id}`);
  const myForm = addLoanFields(new BCFormController(data, { submitSuffix: "" })); // TODO: Add submit suffix
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error}/>;
};

const LmsExternalSystemsUsers = ({ ...props }: IDefaultPagesProps) => {
  const { params = {}, history } = props;
  const allowedActions = [];
  const allowedSubpages = ["add-roles", "add-role-template", "add-loan", "edit-loan"];
  const { isMainPage, isEdit, isActionAllowed, isSubpageAllowed, actionLower, id, query } = useParseRouteActions(params, allowedActions, allowedSubpages);
  const userId = query.get("userId") || id;

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <SystemsUsersMainTable/>}
    {isEdit && <EditExternalUserForm id={userId}/>}
    {isSubpageAllowed && <React.Fragment>
      {actionLower === "add-roles" && <AddRoleTable id={userId}/>}
      {actionLower === "add-role-template" && <AddRoleTemplateForm id={userId}/>}
      {actionLower === "add-loan" && <AddLoanForm id={userId}/>}
      {actionLower === "edit-loan" && <EditLoanForm id={userId}/>}
    </React.Fragment>}
  </React.Fragment>);
};

export default LmsExternalSystemsUsers;